export const MERGE = 'merge';
export const DISCARD = 'discard';
